type Reading = {
  symbol: string;
  name: string;
  value: string;
  unit: string;
  tone: "ok" | "watch";
};

const sampleReadings: readonly Reading[] = [
  { symbol: "NH₃", name: "Ammonia", value: "0.25", unit: "ppm", tone: "watch" },
  { symbol: "NO₂", name: "Nitrite", value: "0", unit: "ppm", tone: "ok" },
  { symbol: "NO₃", name: "Nitrate", value: "40", unit: "ppm", tone: "watch" },
  { symbol: "pH", name: "pH", value: "7.8", unit: "", tone: "ok" },
];

export function TestPanel() {
  return (
    <div className="test-panel">
      <div className="test-panel__head">
        <span>Sample test sheet</span>
        <span>75 gal · freshwater</span>
      </div>
      <ol className="test-panel__rows">
        {sampleReadings.map((reading, index) => (
          <li
            className={`test-panel__row test-panel__row--${reading.tone}`}
            key={reading.name}
            style={{ animationDelay: `${index * 90 + 400}ms` }}
          >
            <span className="test-panel__swatch" aria-hidden="true" />
            <span className="test-panel__symbol">{reading.symbol}</span>
            <span className="test-panel__name">{reading.name}</span>
            <span className="test-panel__value">
              {reading.value}
              {reading.unit ? <small> {reading.unit}</small> : null}
            </span>
          </li>
        ))}
      </ol>
      <p className="test-panel__foot">Bring readings like these to the call and the 15 minutes go a long way.</p>
    </div>
  );
}
